import React from 'react'

import isNil from 'lodash/isNil'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

import CheckboxField from '../checkbox-field'

export interface Props {
  classNames?: string[]
  id?: string
  name?: string
  checked?: boolean
  label: React.ReactNode
  compact?: boolean
  tiny?: boolean
  inline?: boolean
  baseline?: boolean
  size?: 'default' | 's'
  error?: boolean
  partial?: boolean
  highlightError?: boolean
  disabled?: boolean
  count?: React.ReactNode
  suffix?: React.ReactNode
  onChange?: (
    value: boolean,
    name: string | undefined,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
}

const LabeledCheckbox = ({
  classNames,
  id,
  checked,
  label,
  compact = false,
  tiny = false,
  inline = false,
  baseline = false,
  size = 'default',
  error = false,
  highlightError = false,
  partial = false,
  disabled = false,
  count,
  suffix,
  onChange,
  onBlur,
  name,
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <div
      className={cn(
        'LabeledCheckbox',
        {
          compact,
          tiny,
          inline,
          baseline,
          error: error && highlightError,
          disabled,
          [`size-${size}`]: true,
        },
        classNames
      )}
    >
      <CheckboxField
        name={name}
        error={error}
        id={actualId}
        checked={checked}
        disabled={disabled}
        partial={partial}
        onChange={onChange}
        onBlur={onBlur}
      />
      <label htmlFor={actualId} className="LabeledCheckbox__label">
        {label}
      </label>
      {!isNil(count) && <div className="LabeledCheckbox__count">({count})</div>}
      {suffix && <div className="LabeledCheckbox__suffix">{suffix}</div>}
    </div>
  )
}

export default LabeledCheckbox
